module.exports = __webpack_public_path__ + "img/combination.bc584cf1.jpg";